import { AUTO, MAXINT } from './../constants';
import { defined } from './../utils';
export function mwDelta(e) {
    let delta = 0;
    if (e.wheelDelta) {
        delta = -e.wheelDelta / 40;
        delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
    }
    else if (e.detail) {
        delta = e.detail;
    }
    return delta;
}
export function isAutoConnector(connector) {
    return connector.options.name.toLowerCase() === AUTO.toLowerCase();
}
export function closestConnector(point, connectors) {
    let minimumDistance = MAXINT, resCtr, connector;
    for (let i = 0; i < connectors.length; i++) {
        connector = connectors[i];
        if (!isAutoConnector(connector)) {
            const dist = point.distanceTo(connector.position());
            if (dist < minimumDistance) {
                minimumDistance = dist;
                resCtr = connector;
            }
        }
    }
    return resCtr;
}
export function indicesOfItems(group, visuals) {
    const indices = [];
    let i, visual;
    const children = group.drawingContainer().children;
    const length = children.length;
    for (i = 0; i < visuals.length; i++) {
        visual = visuals[i];
        for (let j = 0; j < length; j++) {
            if (children[j] === visual.drawingContainer()) {
                indices.push(j);
                break;
            }
        }
    }
    return indices;
}
export function translateToOrigin(visual) {
    const bbox = visual.drawingContainer().clippedBBox(null);
    if (bbox.origin.x !== 0 || bbox.origin.y !== 0) {
        visual.position(-bbox.origin.x, -bbox.origin.y);
    }
}
export function filterShapeDataItem(dataItem) {
    const result = {};
    dataItem = dataItem || {};
    if (defined(dataItem.text) && dataItem.text !== null) {
        result.text = dataItem.text;
    }
    if (defined(dataItem.x) && dataItem.x !== null) {
        result.x = dataItem.x;
    }
    if (defined(dataItem.y) && dataItem.y !== null) {
        result.y = dataItem.y;
    }
    if (defined(dataItem.width) && dataItem.width !== null) {
        result.width = dataItem.width;
    }
    if (defined(dataItem.height) && dataItem.height !== null) {
        result.height = dataItem.height;
    }
    if (defined(dataItem.type) && dataItem.type !== null) {
        result.type = dataItem.type;
    }
    return result;
}
export function filterConnectionDataItem(dataItem) {
    const result = {};
    dataItem = dataItem || {};
    if (defined(dataItem.text) && dataItem.text !== null) {
        result.content = dataItem.text;
    }
    if (defined(dataItem.type) && dataItem.type !== null) {
        result.type = dataItem.type;
    }
    if (defined(dataItem.from) && dataItem.from !== null) {
        result.from = dataItem.from;
    }
    if (defined(dataItem.fromConnector) && dataItem.fromConnector !== null) {
        result.fromConnector = dataItem.fromConnector;
    }
    if (defined(dataItem.fromX) && dataItem.fromX !== null) {
        result.fromX = dataItem.fromX;
    }
    if (defined(dataItem.fromY) && dataItem.fromY !== null) {
        result.fromY = dataItem.fromY;
    }
    if (defined(dataItem.to) && dataItem.to !== null) {
        result.to = dataItem.to;
    }
    if (defined(dataItem.toConnector) && dataItem.toConnector !== null) {
        result.toConnector = dataItem.toConnector;
    }
    if (defined(dataItem.toX) && dataItem.toX !== null) {
        result.toX = dataItem.toX;
    }
    if (defined(dataItem.toY) && dataItem.toY !== null) {
        result.toY = dataItem.toY;
    }
    return result;
}
export var FlowchartShapeType;
(function (FlowchartShapeType) {
    FlowchartShapeType["Terminator"] = "Terminator";
    FlowchartShapeType["Process"] = "Process";
    FlowchartShapeType["Decision"] = "Decision";
    FlowchartShapeType["PredefinedProcess"] = "PredefinedProcess";
    FlowchartShapeType["Document"] = "Document";
    FlowchartShapeType["MultipleDocuments"] = "MultipleDocuments";
    FlowchartShapeType["ManualInputOutput"] = "ManualInputOutput";
    FlowchartShapeType["Preparation"] = "Preparation";
    FlowchartShapeType["ManualOperation"] = "ManualOperation";
    FlowchartShapeType["InternalStorage"] = "InternalStorage";
    FlowchartShapeType["Display"] = "Display";
    FlowchartShapeType["DirectAccessStorage"] = "DirectAccessStorage";
    FlowchartShapeType["Database"] = "Database";
    FlowchartShapeType["OnPageConnector"] = "OnPageConnector";
    FlowchartShapeType["OffPageConnector"] = "OffPageConnector";
    FlowchartShapeType["DataInputOutput"] = "DataInputOutput";
    FlowchartShapeType["SummingJunction"] = "SummingJunction";
    FlowchartShapeType["LogicalOr"] = "LogicalOr";
    FlowchartShapeType["Merge"] = "Merge";
    FlowchartShapeType["Extract"] = "Extract";
    FlowchartShapeType["DataStorage"] = "DataStorage";
    FlowchartShapeType["Delay"] = "Delay";
    FlowchartShapeType["Sort"] = "Sort";
    FlowchartShapeType["Collate"] = "Collate";
})(FlowchartShapeType || (FlowchartShapeType = {}));
const documentConnectors = [
    { name: "top" },
    {
        name: "bottom",
        position: function (shape) {
            const height = shape.bounds().height;
            const amplitude = height * shape.shapeVisual.options.waveRatio;
            const position = shape.getPosition('top');
            position.y += height - (amplitude * 0.4);
            return position;
        }
    },
    { name: "left" },
    { name: "right" },
    { name: "auto" }
];
const triangleConnectors = [
    { name: "top" },
    { name: "bottom" },
    {
        name: "left",
        position: function (shape) {
            const position = shape.getPosition('left');
            const bounds = shape.bounds();
            position.x += (bounds.width / 4) - shape.shapeVisual.options.cornerRadius * 0.6 * (bounds.width / bounds.height);
            return position;
        }
    },
    {
        name: "right",
        position: function (shape) {
            const position = shape.getPosition('right');
            const bounds = shape.bounds();
            position.x -= bounds.width / 4 - shape.shapeVisual.options.cornerRadius * 0.6 * (bounds.width / bounds.height);
            return position;
        }
    },
    { name: "auto" }
];
export const connectors = {
    [FlowchartShapeType.Extract]: triangleConnectors,
    [FlowchartShapeType.Merge]: triangleConnectors,
    [FlowchartShapeType.Document]: documentConnectors,
    [FlowchartShapeType.MultipleDocuments]: documentConnectors,
    [FlowchartShapeType.DataInputOutput]: [
        { name: "top" },
        { name: "bottom" },
        {
            name: "left",
            position: function (shape) {
                const position = shape.getPosition('left');
                position.x += (shape.bounds().width * shape.shapeVisual.options.slantRatio / 2) - shape.shapeVisual.options.cornerRadius / 5;
                return position;
            }
        },
        {
            name: "right",
            position: function (shape) {
                const position = shape.getPosition('right');
                position.x -= (shape.bounds().width * shape.shapeVisual.options.slantRatio / 2) - shape.shapeVisual.options.cornerRadius / 5;
                return position;
            }
        },
        { name: "auto" }
    ],
    [FlowchartShapeType.ManualOperation]: [
        { name: "top" },
        { name: "bottom" },
        {
            name: "left",
            position: function (shape) {
                const position = shape.getPosition('left');
                position.x += (shape.bounds().width * shape.shapeVisual.options.baseShrinkRatio / (4 + shape.shapeVisual.options.cornerRadius / 10));
                return position;
            }
        },
        {
            name: "right",
            position: function (shape) {
                const position = shape.getPosition('right');
                position.x -= (shape.bounds().width * shape.shapeVisual.options.baseShrinkRatio / (4 + shape.shapeVisual.options.cornerRadius / 10));
                return position;
            }
        },
        { name: "auto" }
    ],
    [FlowchartShapeType.ManualInputOutput]: [
        {
            name: "top",
            position: function (shape) {
                const position = shape.getPosition('top');
                position.y += shape.bounds().height * shape.shapeVisual.options.topSlantRatio / 2;
                return position;
            }
        },
        { name: "bottom" },
        { name: "left" },
        { name: "right" },
        { name: "auto" }
    ],
    [FlowchartShapeType.DataStorage]: [
        { name: "top" },
        { name: "bottom" },
        { name: "left" },
        {
            name: "right",
            position: function (shape) {
                const width = shape.bounds().width;
                const position = shape.getPosition('right');
                position.x -= width * shape.shapeVisual.options.ellipseRadiusXRatio;
                return position;
            }
        },
        { name: "auto" }
    ]
};
